export default[
	{
	  path: '/stores',
	  name: 'stores',
		meta:[{name:'门店'}],
	  component: resolve =>require(['@/views/stores'],resolve)
	},
	{
	  path: '/stores/storesUpdata',
	  name: 'storesUpdata',
		meta:[{name:'门店维护'}],
	  component: resolve =>require(['@/views/stores/storeUpdata'],resolve)
	},
	{
	  path: '/stores/storesList',
	  name: 'storesList',
		meta:[{name:'门店维护'}],
	  component: resolve =>require(['@/views/stores/storeList'],resolve)
	},
	{
	  path: '/setting/storesSign',
	  name: 'storesSign',
		meta:[{name:'门店签约'}],
	  component: resolve =>require(['@/views/stores/storeSign'],resolve)
	},
	{
	  path: '/stores/tj',
	  name: 'tj',
		meta:[{name:'门店签约'}],
	  component: resolve =>require(['@/views/stores/tj'],resolve)
	},
]
	



// WEBPACK FOOTER //
// ./src/router/stores.js